<mat-toolbar
  *ngIf="showMenuInFooter && authenticator.route === 'authenticated'"
>
  <mat-toolbar-row class="p-0">
    <app-header-menu [footer]="true"></app-header-menu>
  </mat-toolbar-row>
</mat-toolbar>

<footer
  class="d-flex flex-wrap align-items-center justify-content-center main-footer-container"
>
  <section class="contact-footer" *ngIf="contactComponentVisible">
    <section class="contact-footer__info">
      <div>
        <img src="assets/pics/contacts/logo-icon.png" />
        <p>
          <strong>{{ "CONTACT.ADDRESS" | translate }}:</strong><br />1222
          Budapest,<br />Borkő utca 12.
        </p>
        <p><strong>E-mail:</strong><br />{{ "info@easylot.hu" }}</p>
      </div>
    </section>
    <section class="contact-footer__map">
      <iframe
        title="map"
        class="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d145275.9692758274!2d18.9582699278362!3d47.42315069972097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741e7a37aed2351%3A0x290cf13a692cba05!2sBudapest%2C%20Bork%C5%91%20u.%2012%2C%201222!5e0!3m2!1shu!2shu!4v1656696720023!5m2!1shu!2shu"
        width="100%"
        height="550px"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </section>
  </section>
  <mat-toolbar class="footer-toolbar pt-4" color="primary">
    <a
      mat-button
      [routerLink]="'/home'"
      aria-label="kezdőoldal"
      class="logo-button"
      ><img
        class="easylot-logo"
        src="assets/pics/easylot-logo.png"
        alt="easylot logo"
    /></a>

    <ul class="link list">
      <div>
        <li>
          <a [routerLink]="'/modules'" mat-button>{{
            "HEADER.BTN.MENU_TITLES.MODULES" | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="'/prices'" mat-button>{{
            "HEADER.BTN.MENU_TITLES.PRICES" | translate
          }}</a>
        </li>
        <li>
          <a mat-button [routerLink]="'/founders'">{{
            "HEADER.BTN.MENU_TITLES.ABOUT" | translate
          }}</a>
        </li>
        <li>
          <a mat-button [routerLink]="'/contact'">{{
            "HEADER.BTN.MENU_TITLES.CONTACT" | translate
          }}</a>
        </li>
      </div>
      <div>
        <li>
          <a
            mat-button
            href="{{ documentsStorageUrl }}/TermsAndConditions.pdf"
            target="_blank"
            >{{ "FOOTER.TERMS" | translate }}</a
          >
        </li>
        <li>
          <a
            mat-button
            href="{{ documentsStorageUrl }}/PrivacyPolicy.pdf"
            target="_blank"
          >
            {{ "FOOTER.PRIVACY" | translate }}
          </a>
        </li>
        <li>
          <button mat-button (click)="openNewsletterDialog()">
            {{ "FOOTER.NEWSLETTER_SUBSCRIPTION" | translate }}
          </button>
        </li>
        <div fxLayout class="socials">
          <li>
            <a
              class="brand-link"
              mat-icon-button
              target="_blank"
              href="https://www.facebook.com/profile.php?id=100088023722684"
              [attr.aria-label]="'FOOTER.FACEBOOK' | translate"
            >
              <mat-icon fontSet="fa-brands" fontIcon="fa-facebook"></mat-icon>
            </a>
          </li>
          <li>
            <a
              class="brand-link"
              mat-icon-button
              target="_blank"
              href="https://www.linkedin.com/company/easylot/"
              [attr.aria-label]="'FOOTER.LINKEDIN' | translate"
            >
              <mat-icon fontSet="fa-brands" fontIcon="fa-linkedin"></mat-icon>
            </a>
          </li>
        </div>
      </div>
    </ul>
    <p class="my-0 version">{{ "Verzió: " + version }}</p>
  </mat-toolbar>
  <a class="gs1" href="https://www.gs1hu.org/" target="_blank">
    <img class="w-100" src="assets/pics/GS1.png" alt="gs1_logo" />
  </a>
</footer>
